import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { validateEmail } from 'src/lib/utils/helpers'

const EmailSent = () => {
  const { t } = useLocale()
  const router = useRouter()
  const { email } = router.query

  useEffect(() => {
    if (!Boolean(validateEmail(String(email)))) {
      router.replace('/auth/login')
    }
  }, [email])

  return (
    <>
      <div className='flex flex-col  max-w-[380px] gap-8 '>
        <h2 className='text-2xl font-semibold text-zinc-700 items-center text-center'>
          {t('login_page.check_your_inbox')}
        </h2>
        <p className='text-text-sm-regular text-center text-zinc-500'>
          {t('login_page.open_email_before')} <span className='text-text-sm-semibold'>{email}</span>{' '}
          {t('login_page.open_email_after')}
        </p>
      </div>
    </>
  )
}

export default EmailSent
